console.log('=== related-products.js loaded ===');

document.addEventListener('DOMContentLoaded', function() {
  console.log('=== DOMContentLoaded fired ===');
  
  const productRecommendations = document.querySelector('product-recommendations');
  if (!productRecommendations) {
    console.log('No product-recommendations element found');
    return;
  }
  
  // Prevent loadRecommendations from being called again
  if (productRecommendations.loadRecommendations) {
    console.log('Storing original loadRecommendations');
    const originalLoadRecommendations = productRecommendations.loadRecommendations.bind(productRecommendations);
    let hasLoaded = false;
    
    productRecommendations.loadRecommendations = function(productId) {
      if (hasLoaded) {
        console.log('loadRecommendations already called, skipping');
        return;
      }
      hasLoaded = true;
      console.log('Calling original loadRecommendations');
      originalLoadRecommendations(productId);
    };
  }
  
  function restructureContent() {
    console.log('=== restructureContent called ===');
    console.trace('Call stack:');
    
    if (productRecommendations.hasAttribute('data-restructured')) {
      console.log('Already restructured');
      return;
    }
    
    const heading = productRecommendations.querySelector('.related-products__heading');
    const productGrid = productRecommendations.querySelector('.grid.product-grid') || productRecommendations.querySelector('ul[role="list"]');
    
    if (!heading || !productGrid) {
      console.log('Heading or productGrid not found');
      return;
    }
    
    const productItems = productGrid.querySelectorAll('.grid__item, li');
    console.log('Found product items:', productItems.length);
    
    if (productItems.length === 0) {
      console.log('No products found');
      productRecommendations.style.display = 'none';
      return;
    }
    
    const imageRatio = productRecommendations.getAttribute('data-image-ratio') || '4-3';
    const sellingPointsCount = parseInt(productRecommendations.getAttribute('data-selling-points-count')) || 4;
    const sellingPointsShow = productRecommendations.getAttribute('data-selling-points-show') === 'true';
    const columnsDesktop = parseInt(productRecommendations.getAttribute('data-columns-desktop')) || 4;
    const columnsMobile = parseInt(productRecommendations.getAttribute('data-columns-mobile')) || 2;
    
    const isMobile = window.innerWidth < 750;
    const itemsPerPage = isMobile ? columnsMobile : columnsDesktop;
    
    console.log('Settings:', { imageRatio, sellingPointsCount, sellingPointsShow, itemsPerPage });
    
    productRecommendations.setAttribute('data-image-ratio', imageRatio);
    
    const processItems = async () => {
      console.log('=== Processing items ===');
      const filteredItems = [];
      
      for (const item of productItems) {
        const cardWrapper = item.querySelector('.card-wrapper');
        if (!cardWrapper) continue;
        
        const productLink = cardWrapper.querySelector('a[href*="/products/"]');
        if (!productLink) continue;
        
        const productUrl = productLink.getAttribute('href');
        const productHandle = productUrl.split('/products/')[1]?.split('?')[0];
        
        try {
          const response = await fetch(`/products/${productHandle}.js`);
          const product = await response.json();
          
          filteredItems.push({ item, product });
          console.log('Added product:', productHandle);
          
        } catch (error) {
          console.error('Error:', error);
        }
      }
      
      console.log('Total filtered items:', filteredItems.length);
      
      if (filteredItems.length === 0) {
        productRecommendations.style.display = 'none';
        return;
      }
      
      filteredItems.forEach(({ item, product }) => {
        const newItem = document.createElement('li');
        newItem.className = 'grid__item';
        newItem.innerHTML = item.innerHTML;
        
        // Debug: Check if cart button exists
        const cartButton = newItem.querySelector('.card__cart-icon');
        console.log('Cart button in newItem:', cartButton);
        if (cartButton) {
          console.log('Cart button data-product-id:', cartButton.dataset.productId);
        }
        
        const cardInfo = newItem.querySelector('.card__information');
        if (cardInfo) {
          const priceElement = cardInfo.querySelector('.price');
          
          if (product.description) {
            const descDiv = document.createElement('div');
            descDiv.className = 'related-products__description';
            const plainDesc = product.description.replace(/<[^>]*>/g, '').substring(0, 150);
            descDiv.textContent = plainDesc + (product.description.length > 150 ? '...' : '');
            
            const heading = cardInfo.querySelector('.card__heading');
            if (heading) {
              heading.insertAdjacentElement('afterend', descDiv);
            } else {
              cardInfo.insertBefore(descDiv, cardInfo.firstChild);
            }
          }
          
          if (priceElement) {
            const descElement = cardInfo.querySelector('.related-products__description');
            if (descElement) {
              descElement.insertAdjacentElement('afterend', priceElement);
            }
          }
        }
        
        const aboveImageContainer = document.createElement('div');
        aboveImageContainer.className = 'related-products__above-image';
        
        if (product.compare_at_price > product.price) {
          const discountAmount = product.compare_at_price - product.price;
          const discountBadge = document.createElement('div');
          discountBadge.className = 'related-products__discount-badge';
          discountBadge.textContent = `$${(discountAmount / 100).toFixed(2)} OFF`;
          aboveImageContainer.appendChild(discountBadge);
        }
        
        const commonTags = ['All', 'Show Parameters', 'us warehouse', 'UK', 'electric scooter', 'electric bike', 'electric dirt bike'];
        const tagsToShow = product.tags.filter(tag => !commonTags.includes(tag));
        
        if (tagsToShow.length > 0) {
          const tagsContainer = document.createElement('div');
          tagsContainer.className = 'related-products__tags-container';
          
          tagsToShow.forEach(tag => {
            const tagSpan = document.createElement('span');
            tagSpan.className = 'related-products__tag';
            tagSpan.textContent = tag;
            tagsContainer.appendChild(tagSpan);
          });
          
          aboveImageContainer.appendChild(tagsContainer);
        }
        
        const cardInner = newItem.querySelector('.card__inner');
        if (cardInner && aboveImageContainer.hasChildNodes()) {
          cardInner.insertBefore(aboveImageContainer, cardInner.firstChild);
        }
        
        if (sellingPointsShow) {
          const sellingPointsDiv = document.createElement('div');
          sellingPointsDiv.className = 'related-products__selling-points';
          
          const metafields = product.metafields?.custom;
          if (metafields) {
            const allSellingPoints = [
              { key: 'motor', label: 'Motor' },
              { key: 'battery', label: 'Battery' },
              { key: 'speed', label: 'Max Speed' },
              { key: 'range', label: 'Max Range' },
              { key: 'tire_size', label: 'Tire Size' },
              { key: 'brake_type', label: 'Brake Type' },
              { key: 'max_load', label: 'Max Load' },
              { key: 'standard_voltage', label: 'Standard Voltage' },
              { key: 'charging_time', label: 'Charging Time' }
            ];
            
            const sellingPointItems = [];
            for (const point of allSellingPoints) {
              if (metafields[point.key]) {
                sellingPointItems.push({
                  value: metafields[point.key],
                  label: point.label
                });
                
                if (sellingPointItems.length >= sellingPointsCount) {
                  break;
                }
              }
            }
            
            if (sellingPointItems.length > 0) {
              const gridDiv = document.createElement('div');
              gridDiv.className = 'selling-points-grid';
              
              sellingPointItems.forEach(item => {
                const itemDiv = document.createElement('div');
                itemDiv.className = 'selling-point-item';
                
                const valueP = document.createElement('p');
                valueP.className = 'selling-point-value';
                valueP.textContent = item.value;
                
                const labelP = document.createElement('p');
                labelP.className = 'selling-point-label';
                labelP.textContent = item.label;
                
                itemDiv.appendChild(valueP);
                itemDiv.appendChild(labelP);
                gridDiv.appendChild(itemDiv);
              });
              
              sellingPointsDiv.appendChild(gridDiv);
            }
          }
          
          const cardInner = newItem.querySelector('.card__inner');
          if (cardInner && sellingPointsDiv.querySelector('.selling-points-grid')) {
            cardInner.appendChild(sellingPointsDiv);
          }
        }
        
        productGrid.appendChild(newItem);
        console.log('Appended new item to grid, total children:', productGrid.children.length);
      });
      
      // Remove original product items to avoid duplicates
      productItems.forEach(item => {
        item.remove();
      });
      
      const allItems = Array.from(productGrid.children);
      console.log('All items after removing originals:', allItems.length);
      const totalPages = Math.ceil(allItems.length / itemsPerPage);
      let currentPage = 0;
      
      console.log('Pagination:', { totalItems: allItems.length, itemsPerPage, totalPages });
      
      // Use existing pagination buttons
      const prevBtn = document.getElementById('related-products-prev');
      const nextBtn = document.getElementById('related-products-next');
      
      if (!prevBtn || !nextBtn) {
        console.log('Pagination buttons not found');
        return;
      }
      
      function showPage(pageIndex) {
        const startIndex = pageIndex * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, allItems.length);
        
        console.log('Show page:', pageIndex, 'items:', startIndex, '-', endIndex);
        
        allItems.forEach(item => {
          item.classList.remove('visible');
        });
        
        for (let i = startIndex; i < endIndex; i++) {
          allItems[i].classList.add('visible');
          console.log('Added visible class to item', i, 'classList:', allItems[i].classList.toString());
          console.log('Item', i, 'computed display:', window.getComputedStyle(allItems[i]).display);
        }
        
        prevBtn.disabled = pageIndex === 0;
        nextBtn.disabled = pageIndex >= totalPages - 1;
      }
      
      showPage(0);
      console.log('Initial page shown');
      
      prevBtn.addEventListener('click', () => {
        if (currentPage > 0) {
          currentPage--;
          showPage(currentPage);
        }
      });
      
      nextBtn.addEventListener('click', () => {
        if (currentPage < totalPages - 1) {
          currentPage++;
          showPage(currentPage);
        }
      });
      
      productRecommendations.setAttribute('data-hidden', 'false');
      productRecommendations.setAttribute('data-restructured', 'true');
      console.log('=== Done ===');
    };
    
    processItems();
  }
  
  productRecommendations.addEventListener('recommendations:loaded', () => {
    console.log('recommendations:loaded event');
    restructureContent();
  });
  
  const initialHeading = productRecommendations.querySelector('.related-products__heading');
  const initialGrid = productRecommendations.querySelector('.grid.product-grid') || productRecommendations.querySelector('ul[role="list"]');
  
  console.log('initialHeading:', initialHeading);
  console.log('initialGrid:', initialGrid);
  
  if (initialHeading && initialGrid) {
    console.log('Already loaded');
    restructureContent();
  } else if (productRecommendations.loadRecommendations) {
    console.log('Manually loading');
    productRecommendations.loadRecommendations(productRecommendations.dataset.productId);
  }
  
  const observer = new MutationObserver((mutations) => {
    console.log('MutationObserver triggered, mutations:', mutations);
    console.log('productRecommendations.classList:', productRecommendations.classList.toString());
    if (productRecommendations.classList.contains('product-recommendations--loaded')) {
      console.log('Found product-recommendations--loaded class');
      observer.disconnect();
      restructureContent();
    } else {
      console.log('No product-recommendations--loaded class yet');
    }
  });
  
  observer.observe(productRecommendations, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
});